import { fr, enUS, it, es, de } from 'date-fns/locale';
import i18n from '../i18n';

const localeMap = {
  fr: fr,
  en: enUS,
  it: it,
  es: es,
  de: de
};

export const getDateLocale = () => {
  const lang = i18n.language?.split('-')[0] || 'fr';
  return localeMap[lang] || fr;
};
